
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { IHandoverSetting, createArrayCopyAndSort, createScheduleSide, findFirstAndLastEntry, makeSideToMatch, mergeAndClean, modifyTimePlace } from '../ScheduleCalc';

const applyChanges = (schedule:ISchedule, selectedDays:IDateRange[], pickupA:IHandoverSetting[], pickupB:IHandoverSetting[], 
  additionalTime:number):ISchedule => {

  const newSchedule:ISchedule = {
    id:schedule.id,
    lastHandover:schedule.lastHandover,
    status:schedule.status,
    name:schedule.name,
    school:schedule.school,
    data:{
      children:schedule.data.children,
      parentA:schedule.data.parentA,
      parentB:schedule.data.parentB,
      scheduleEntriesParentA:{},
      scheduleEntriesParentB:{},
    }
  }

  const modifiedEntries = mergeAndClean(modifyTimePlace(createArrayCopyAndSort(schedule.data.scheduleEntriesParentA),
    selectedDays,pickupA,pickupB,additionalTime));
  const foundEntries = findFirstAndLastEntry(schedule.data.scheduleEntriesParentB);
  const matchingEntries = makeSideToMatch(modifiedEntries, foundEntries.firstEntry, foundEntries.lastEntry);
  newSchedule.data.scheduleEntriesParentA = createScheduleSide(modifiedEntries);
  newSchedule.data.scheduleEntriesParentB = createScheduleSide(matchingEntries);

  return newSchedule;
}

// returns an array with 7 entries with a count on the number of handovers occuring that day ( 0 = sunday )
const calculateHandoverDays = (selectedDays:IDateRange[], schedule:ISchedule|undefined)
    :{parentApickupDays:number[], parentBpickupDays:number[]} => {
    const parentApickupDays:number[] = [0,0,0,0,0,0,0];
    const parentBpickupDays:number[] = [0,0,0,0,0,0,0];

    if (schedule !== undefined) {

      const sideA = schedule.data.scheduleEntriesParentA;
      const sideB = schedule.data.scheduleEntriesParentB;

      for ( const key of Object.keys(sideA)) {
        const entry = sideA[key];
        for (const selection of selectedDays) {
          if (entry.startTime >= selection.start && entry.startTime <= selection.end) {
            const pickup:Date = new Date(entry.startTime);
            parentApickupDays[pickup.getDay()] = parentApickupDays[pickup.getDay()]+1;
          }
        }
      }

      for ( const key of Object.keys(sideB)) {
        const entry = sideB[key];
        for (const selection of selectedDays) {
          if (entry.startTime >= selection.start && entry.startTime <= selection.end) {
            const pickup:Date = new Date(entry.startTime);
            parentBpickupDays[pickup.getDay()] = parentBpickupDays[pickup.getDay()]+1;
          }
        }
      }
  
    }

    return {parentApickupDays, parentBpickupDays};
  }

export { calculateHandoverDays, applyChanges };


// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/ChangeTimePlace/ChangeTimePlaceCalc.ts